<kendo-dialog [width]="getDialogWidth()" *ngIf="flagOpened" (close)="closeEditForm()">
  <kendo-dialog-titlebar>
    <h3 *ngIf="isNew && memberId">{{'ADD-MEMBER-FLAG-MULTI' | translate:patientLabel}}</h3>
    <h3 *ngIf="isNew && caseId">{{'ADD-CASE-FLAG-MULTI' | translate}}</h3>
    <h3 *ngIf="!isNew">{{ 'EDIT-FLAG' | translate }}</h3>
  </kendo-dialog-titlebar>
  <form [formGroup]="flagForm" class="k-form" *ngIf="loaded" style="padding:10px!important">
    <div class="row">
      <div class="col-5 mb-2">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CATEGORY' | translate}} *
          </span>
        </label>
        <kendo-combobox id="category" formControlName="category" [data]="flagCategories" [textField]="'displayName'"
          [valueField]="'id'" class="w-100" tabindex="1" (valueChange)="getFlags($event,false)">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <i class="fas {{dataItem.icon}}" style="color:gray;width:25px"></i>&nbsp;{{ dataItem.displayName }}
          </ng-template>
        </kendo-combobox>
        <div class="k-tooltip k-tooltip-validation" role="alert"
          *ngIf="category.hasError('required') && category.touched">
          {{ 'CATEGORY-REQUIRED' | translate }}
        </div>
      </div>
      <div class="col-1">
      </div>
      <div class="col-3 mb-2">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'PRIORITY' | translate}} *
          </span>
        </label>
        <kendo-combobox id="priority" formControlName="priority" [data]="flagPriorities" [textField]="'displayName'"
          [valueField]="'id'" tabindex="3" class="w-100">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <i class="fa fa-circle flag-priority-color-{{dataItem.code}}"></i>&nbsp;{{ dataItem.displayName }}
          </ng-template>
        </kendo-combobox>
        <div class="k-tooltip k-tooltip-validation" role="alert"
          *ngIf="priority.hasError('required') && priority.touched">
          {{ 'PRIORITY-REQUIRED' | translate }}
        </div>
      </div>
      <div class="col-3 mb-2 text-center" *ngIf="false">
        <label class="k-form-field text-center">
          <span class="k-text-uppercase dark">
            {{'PRIVATE' | translate}}
          </span>
        </label>
        <kendo-switch formControlName="privacy" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}"
          tabindex="4">
        </kendo-switch>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-2">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{ (isNew ? 'FLAGS' : 'FLAG') | translate}} * <span *ngIf="!isNew" kendoTooltip
              [tooltipTemplate]="flagTimestampTemplate" position="right" class="keyboard-accessible" tabindex="0"
              showOn="none" (focus)="showTooltip(flagsTooltip)" (mouseover)="showTooltip(flagsTooltip)"
              (blur)="hideTooltip()" (mouseout)="hideTooltip()" aria-live="polite">
              <i #flagsTooltip title="" class="fa fa-info-circle pointer"></i>
            </span>
          </span>
        </label>
        <kendo-autocomplete #singleSelect *ngIf="!isNew" [data]="allFlagsFiltered" [valueField]="'displayName'"
          [textField]="'displayName'" [virtual]="virtualFlag" class="w-100" [suggest]="true" [highlightFirst]="true"
          [filterable]="true" (filterChange)="filterAllFlags($event)" (close)="searchTerm=''"
          (click)="singleSelect.toggle(true)" formControlName="description" tabindex="2">
          <ng-template kendoAutoCompleteItemTemplate let-dataItem>
            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
            </span>
          </ng-template>
        </kendo-autocomplete>
        <kendo-multiselect #multiSelect *ngIf="isNew" type="text" [data]="allFlagsFiltered" valueField="displayName"
          textField="displayName" formControlName="description" [filterable]="true"
          (filterChange)="filterAllFlags($event)" (close)="searchTerm=''" [valueNormalizer]="flagNormalizer"
          [allowCustom]="true">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
            </span>
          </ng-template>
        </kendo-multiselect>
        <div class="k-tooltip k-tooltip-validation" role="alert"
          *ngIf="description.hasError('required') && description.touched">
          {{ 'FLAG-REQUIRED' | translate }}
        </div>
      </div>
    </div>
  </form>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button appPreventClick kendoButton *ngIf="!isNew" style="position:absolute;left:15px"
      (click)="deleteConfirmationOpened = true">{{ 'DELETE' | translate}}
    </button>
    <button kendoButton (click)="closeEditForm($event)">{{ 'CANCEL' | translate}}</button>
    <button appPreventClick kendoButton [primary]="true" [disabled]="!flagForm.valid || !flagForm.dirty"
      (click)="onSave($event)">{{ 'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
<!--Note deletion confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteConfirmationOpened"
  (close)="deleteConfirmationOpened=false" [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-DELETION' | translate }}</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="deleteConfirmationOpened = false">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="onDelete($event); deleteConfirmationOpened = false;"
      [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<ng-template #flagTimestampTemplate>
  <span>
    {{'ADDED-BY-TIMESTAMP' | translate}}&nbsp;<strong>{{flag.createdBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
    translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(flag.createdOn),'g')}}</strong>
  </span>
  <br />
  <span>
    {{'UPDATED-BY-TIMESTAMP' | translate}}&nbsp;<strong>{{flag.lastModifiedBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
    translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(flag.lastModifiedOn),'g')}}</strong>
  </span>
</ng-template>